import React from "react";
import "../Offer-post/Offer-post.css";
import offerImg from "../Offer-post/image-04.webp";
import offerBadge from "../Offer-post/logo-2.webp";
import { Link } from "react-router-dom";

const OfferPost = () => {
  return (
    <section className="offer-post">
      <div className="background"></div>
      <div className="overlayy"></div>
      <div className="content">
        <div className="text-left">
          <p className="special-text">SPECIAL OFFER FOR YOU</p>
          <h1>Let’s Make Your Travel Dreams Come True</h1>
          <p className="desc">
            There are many variations of passages of Lorem Ipsum available but
            the majority.
          </p>
          <Link to="/destination">
            <button className="start-btn">Start Booking</button>
          </Link>
        </div>
        <div className="image-right">
          <img src={offerImg} alt="Offer" className="main-imgg" />
          <img src={offerBadge} alt="Offer Badge" className="badge-img" />
        </div>
      </div>
    </section>
  );
};

export default OfferPost;
